import { render, staticRenderFns } from "./HomeEndowment.vue?vue&type=template&id=bfa6bc0a&scoped=true&"
import script from "./HomeEndowment.vue?vue&type=script&lang=js&"
export * from "./HomeEndowment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6bc0a",
  null
  
)

export default component.exports